import React from "react";

interface Props {
  filters: {
    search: string;
    status: string;
    priority: string;
    department: string;
  };
  onChange: (key: string, value: string) => void;
  onReset: () => void;
}

const TicketFilters: React.FC<Props> = ({ filters, onChange, onReset }) => {
  return (
    <div className="ticket-filters">
      <input
        type="text"
        placeholder="Search by subject / ticket no"
        value={filters.search}
        onChange={(e) => onChange("search", e.target.value)}
      />

      <select
        value={filters.status}
        onChange={(e) => onChange("status", e.target.value)}
      >
        <option value="">All Status</option>
        <option value="Open">Open</option>
        <option value="Pending">Pending</option>
        <option value="In Progress">In Progress</option>
        <option value="Resolved">Resolved</option>
        <option value="Closed">Closed</option>
      </select>

      <select
        value={filters.priority}
        onChange={(e) => onChange("priority", e.target.value)}
      >
        <option value="">All Priority</option>
        <option value="Low">Low</option>
        <option value="Medium">Medium</option>
        <option value="High">High</option>
        <option value="Urgent">Urgent</option>
      </select>

      <select
        value={filters.department}
        onChange={(e) => onChange("department", e.target.value)}
      >
        <option value="">All Department</option>
        <option value="Technical">Technical</option>
        <option value="Billing">Billing</option>
        <option value="Sales">Sales</option>
        <option value="General">General</option>
      </select>

      <button type="button" className="ticket-reset-btn" onClick={onReset}>
        Reset
      </button>
    </div>
  );
};

export default TicketFilters;
